export const subStringProdTitle = (text) => {
    const sliced = text.substring(0, 20) + "...";
    const title = sliced.padEnd(20, ' ');
    return title;
}

export const subStringProdDescription = (text) => {
    const sliced = text.substring(0, 94);
    return sliced.padEnd(94, ' ');
}